import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import BaiduMap from 'vue-baidu-map'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.config.productionTip = false

Vue.use(BaiduMap, {
  ak: 'SZHD5gbsy1MNGu6cOap7R7uNEgvEmK8c'
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
